'use strict';

(() => {
  const template = document.createElement('template');

  template.innerHTML = /* html */ `
    <style>
      .container-default { padding: 1.5rem 0 4rem; }
    </style>

    <div class="container-default">
      <slot></slot>
    </div>
    `;

  class DefaultContainer extends HTMLElement {
    #root = null;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'closed' });
      this.#root.appendChild(template.content.cloneNode(true));
    }
  }

  customElements.define('default-container', DefaultContainer);
})();
